import React from "react";
import { useTranslation } from "react-i18next";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { Calendar } from "@common/calendar";
import { ActivityWatcher } from "@common/activityWatcher";
import { Props } from "./types";
import styles from "./styles.scss";

function DateForm({ startDate, endDate, setStartDate, setEndDate }: Props) {
  const { t } = useTranslation();
  const start = new Date(startDate || new Date());
  const end = new Date(endDate || new Date());

  return (
    <ActivityWatcher className={styles.dateForm}>
      <VisibilityWatcher className={styles.group}>
        {(isVisible, show, hide) => (
          <React.Fragment>
            {isVisible && (
              <div className={styles.calendar}>
                <Calendar
                  date={{
                    year: start.getFullYear(),
                    month: start.getMonth(),
                    day: start.getDate(),
                  }}
                  clear={() => setStartDate("")}
                  editDate={(date) => {
                    const nextDate = new Date(
                      date.year,
                      date.month,
                      date.day,
                    ).toISOString();

                    setStartDate(nextDate === startDate ? "" : nextDate);
                  }}
                />
              </div>
            )}
            <h3 className={styles.titleStart}>
              {t("projectDetails.startDateTitle")}
            </h3>
            <label className={styles.wrapper}>
              <input
                className={styles.input}
                value={
                  startDate ? new Date(startDate).toLocaleDateString() : ""
                }
                onFocus={show}
                readOnly
              />
            </label>
          </React.Fragment>
        )}
      </VisibilityWatcher>
      <VisibilityWatcher className={styles.group}>
        {(isVisible, show, hide) => (
          <React.Fragment>
            {isVisible && (
              <div className={styles.calendar}>
                <Calendar
                  date={{
                    year: end.getFullYear(),
                    month: end.getMonth(),
                    day: end.getDate(),
                  }}
                  clear={() => setEndDate("")}
                  editDate={(date) => {
                    const nextDate = new Date(
                      date.year,
                      date.month,
                      date.day,
                    ).toISOString();

                    setEndDate(nextDate === endDate ? "" : nextDate);
                  }}
                />
              </div>
            )}
            <h3 className={styles.titleEnd}>
              {t("projectDetails.endDateTitle")}
            </h3>
            <label className={styles.wrapper}>
              <input
                className={styles.input}
                value={endDate ? new Date(endDate).toLocaleDateString() : ""}
                onFocus={show}
                readOnly
              />
            </label>
          </React.Fragment>
        )}
      </VisibilityWatcher>
    </ActivityWatcher>
  );
}

export { DateForm };
